import ClassenService from '../ClassenService';

class RegionService {
  getRegions() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/regions`);
  }

  addRegion(regionData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/regions`, 'addRegion', regionData);
  }

  getRegion(regionId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/regions/${regionId}`);
  }

  updateRegion(regionId, regionData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/regions/${regionId}`, 'updateRegion', regionData);
  }

  deleteRegion(regionId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/regions/${regionId}`, 'deleteRegion');
  }
}

export default new RegionService();
